import axios from '@/utils/request';

let prefix = process.env.VUE_APP_API_PREFIX_2;

// 获取用户列表
const GetUserList = params => {
  return axios.get(prefix + '/user/GetUserList', {
    params
  });
};

// 获取用户详情
const GetUserRecord = params => {
  return axios.get(prefix + '/user/GetUserRecord', {
    params
  });
};

// 创建用户
const CreateUser = data => {
  return axios.post(prefix + '/user/CreateUser', data);
};

// 修改用户
const UpdateUser = data => {
  return axios.put(prefix + '/user/UpdateUser', data);
};

// 删除用户
const DeleteUser = data => {
  return axios.delete(prefix + '/user/DeleteUser', data);
};

// 重置密码
const ResetPassword = data => {
  return axios.put(prefix + '/user/ResetPassword', data);
};

// 修改用户状态
const UpdateUserStatus = data => {
  return axios.put(prefix + '/user/UpdateUserStatus', data);
};

// 授权设备
const SetUserDeviceAuth = data => {
  return axios.post(prefix + '/user/SetUserDeviceAuth', data);
};

// 授权产品
const SetUserProductAuth = data => {
  return axios.post(prefix + '/user/SetUserProductAuth', data);
};

// 获取邮箱验证码
const SendEmailCode = params => {
  return axios.get(prefix + '/SendEmailCode', {
    params
  });
};

// 验证当前密码
const CheckPassword = data => {
  return axios.post(prefix + '/user/CheckPassword', data);
};

// 验证当前密码
const CheckSmsCode = data => {
  return axios.post(prefix + '/user/CheckSmsCode', data);
};

// 修改用户头像
const EditAvatar = data => {
  return axios.put(prefix + '/user/EditAvatar', data);
};

// 修改用户名
const EditUsername = data => {
  return axios.put(prefix + '/user/EditUsername', data);
};

// 修改密码
const EditPassword = data => {
  return axios.put(prefix + '/user/EditPassword', data);
};

// 修改手机号
const EditMobile = data => {
  return axios.put(prefix + '/user/EditMobile', data);
};

// 修改邮箱
const EditEmail = data => {
  return axios.put(prefix + '/user/EditEmail', data);
};

// 绑定手机号码
const BindMobile = data => {
  return axios.post(prefix + '/user/BindMobile', data);
};

// 绑定邮箱
const BindEmail = data => {
  return axios.post(prefix + '/user/BindEmail', data);
};

// 获取用户设备 | 产品授权
const GetUserAuth = params => {
  return axios.get(prefix + '/user/GetUserAuth', {
    params
  });
};

// 获取用户登录记录
const GetLoginLog = params => {
  return axios.get(prefix + '/user/GetLoginLog', {
    params
  });
};

// 获取平台首位用户信息
const GetSystemCustomerInfo = params => {
  return axios.get(prefix + '/GetSystemCustomerInfo', {
    params
  });
};

// 获取证书相关数量信息
const GetLicenseInfo = params => {
  return axios.get(prefix + '/user/GetLicenseInfo', {
    params
  });
};

// 是否第一次登录
const IsFirstLogin = params => {
  return axios.get(prefix + '/user/IsFirstLogin', {
    params
  });
};

// 获取平台是否已经初始化
const GetInitStatus = params => {
  return axios.get(prefix + '/GetInitStatus', {
    params
  });
};

// 解除绑定微信
const UnbindWx = data => {
  return axios.put(prefix + '/user/UnbindWx', data);
};

export {
  GetUserList,
  GetUserRecord,
  CreateUser,
  UpdateUser,
  DeleteUser,
  ResetPassword,
  UpdateUserStatus,
  SetUserDeviceAuth,
  SetUserProductAuth,
  SendEmailCode,
  CheckPassword,
  CheckSmsCode,
  EditAvatar,
  EditUsername,
  EditPassword,
  EditMobile,
  EditEmail,
  BindMobile,
  BindEmail,
  GetUserAuth,
  GetLoginLog,
  GetSystemCustomerInfo,
  GetLicenseInfo,
  IsFirstLogin,
  GetInitStatus,
  UnbindWx
};
